import easyeducation from '../assets/logos/easyE-min.webp';
import drumster from '../assets/logos/drumster-min.webp';
// import yachtsafe from '../assets/logos/yachtsafe-min.webp';
import polarpumpen from '../assets/logos/polarpumpen-min.webp';
import detecht from '../assets/logos/detecht-min.webp';
// import installationspartner from '../assets/logos/installationspartner-min.webp';
import notkarnan from '../assets/logos/notkarnan-min.webp';
// import stenastal from '../assets/logos/stenastal-min.webp';
import adfenix from '../assets/logos/adfenix-min.webp';
import connectwest from '../assets/logos/connectwest-min.webp';
import yuncture from '../assets/logos/yuncture-min.webp';
import venturecup from '../assets/logos/venturecup-min.webp';

import easyeducationFall from '../assets/logos/easyE-min.png';
import drumsterFall from '../assets/logos/drumster-min.png';
// import yachtsafeFall from '../assets/logos/yachtsafe-min.png';
import polarpumpenFall from '../assets/logos/polarpumpen-min.png';
import detechtFall from '../assets/logos/detecht-min.png';
// import installationspartnerFall from '../assets/logos/installationspartner-min.png';
import notkarnanFall from '../assets/logos/notkarnan-min.png';
// import stenastalFall from '../assets/logos/stenastal-min.png';
import adfenixFall from '../assets/logos/adfenix-min.png';
import connectwestFall from '../assets/logos/connectwest-min.png';
import yunctureFall from '../assets/logos/yuncture-min.png';
import venturecupFall from '../assets/logos/venturecup-min.png';
// import abiliaFall from '../assets/logos/abilia-logo.png';

import blaklader from '../assets/logos/png/blaklader.png';
import forza from '../assets/logos/png/forza.png';
import gbgTechWeek from '../assets/logos/png/gbg-tech-week.png';
import headsup from '../assets/logos/png/headsup.png';
import insertcoin from '../assets/logos/png/insertcoin.png';
import polestar from '../assets/logos/png/polestar.png';
import seb from '../assets/logos/png/seb.png';
import thermo from '../assets/logos/png/thermo.png';
import vow from '../assets/logos/png/vow.png';
import sundbyberg from '../assets/logos/png/sundbyberg.png';
import dialiv from '../assets/logos/png/dialiv.png';
import huawei from '../assets/logos/png/huawei.png';

export default [
  {
    id: 115,
    logo: { fall: polestar },
  },
  {
    id: 0,
    logo: { fall: blaklader },
  },
  {
    id: 11,
    logo: { fall: forza },
    style: { width: '85%' },
  },
  {
    id: 5,
    logo: { main: detecht, fall: detechtFall },
    path: 'detecht',
    style: { marginBottom: 30 },
    extraClass: 'logoLarge',
  },
  {
    id: 117,
    logo: { fall: thermo },
  },
  {
    id: 13,
    logo: { main: venturecup, fall: venturecupFall },
    path: '',
  },

  {
    id: 119,
    logo: { fall: sundbyberg },
  },
  {
    id: 113,
    logo: { fall: headsup },
  },
  {
    id: 1,
    logo: { main: easyeducation, fall: easyeducationFall },
    path: 'easy-education',
  },
  {
    id: 122,
    logo: { fall: dialiv },
  },
  {
    id: 116,
    logo: { fall: seb },
    style: { width: '85%' },
  },
  {
    id: 118,
    logo: { fall: vow },
    style: { width: '90%' },
  },
  {
    id: 12,
    logo: { fall: gbgTechWeek },
  },
  {
    id: 2,
    logo: { main: drumster, fall: drumsterFall },
    path: 'drumster',
  },
  {
    id: 114,
    logo: { fall: insertcoin },
  },
  // {
  //   id: 119,
  //   logo: { fall: huawei },
  // },
  // {
  //   id: 3,
  //   logo: { main: yachtsafe, fall: yachtsafeFall },
  //   path: 'yachtsafe',
  //   style: { marginBottom: 30 },
  //   extraClass: 'logoLarge',
  // },
  {
    id: 4,
    logo: { main: polarpumpen, fall: polarpumpenFall },
    path: 'polarpumpen',
    style: { marginBottom: 43 },
    extraClass: 'logoLarge',
  },

  {
    id: 7,
    logo: { main: notkarnan, fall: notkarnanFall },
    path: '',
  },
  // {
  //   id: 8,
  //   logo: { main: stenastal, fall: stenastalFall },
  //   path: '',
  // },
  {
    id: 9,
    logo: { main: adfenix, fall: adfenixFall },
    path: '',
  },
  {
    id: 10,
    logo: { main: connectwest, fall: connectwestFall },
    path: '',
  },
  // {
  //   id: 6,
  //   logo: {
  //     main: installationspartner,
  //     fall: installationspartnerFall,
  //   },
  //   path: 'installationspartner',
  //   extraClass: 'logoMedium',
  // },
  {
    id: 12,
    logo: { main: yuncture, fall: yunctureFall },
    path: '',
  },
  // {
  //   id: 14,
  //   logo: { fall: abiliaFall },
  //   path: '/abilia',
  // },
];
